/**
 * Stamps every operator-supplied reason with the acting mops user's
 * email so the audit trail reads `*nsb@onrepeatnow.com via MOPS* <reason>`
 * from the moment it lands in the audit sink. Both the memory pane and the
 * sessions pane forward it through `logger.info` — deletes are hard with no
 * DB column for the reason, so log-only retention is the accepted tradeoff.
 *
 * `null` email is a defensive fallback — `AuthProvider` blocks render
 * until `user` is non-null, so this only fires if a future caller
 * decouples from auth.
 */
export function prefixReason(reason: string, email: string | null): string {
  const stamp = email ? `*${email} via MOPS*` : '*via MOPS*';
  return `${stamp} ${reason.trim()}`;
}
